// extracted by mini-css-extract-plugin
export default {"toast":"Toast_toast__BiBj6","toast-slide":"Toast_toast-slide__K03QK"};